import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter} from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { createQueryClient } from '@/lib/query-client'

import { routeTree } from './routeTree.gen'
import '@/styles.css'

// Optional: ThemeProvider and Toaster, if available
// import { ThemeProvider } from '@/components/theme-provider';
// import { Toaster } from '@/components/ui/sonner';

// Optional: ReactQueryDevtools if available
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const queryClient = createQueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* <AppBootstrap /> */}
      {/* Uncomment ThemeProvider and Toaster if available in your project */}
      {/* <ThemeProvider defaultTheme="system" storageKey="cms-theme"> */}
      <RouterProvider router={router} />
      {/* <Toaster /> */}
      {/* </ThemeProvider> */}
      {/* Uncomment if ReactQueryDevtools is available */}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </StrictMode>,
)
